import api from "./api";

export const addAccount = async (account: any): Promise<any> => {
  const { data } = await api.post("/admin/accounts", account);

  return data.account;
};
